export default "__VITE_ASSET__CyhlsrFJ__"